export const TABS_HEADING_SPACING = 'pt-4';
export const TABS_CONTENT_SPACING = 'pt-2';

export const IMAGE_URL = 'https://content.breakfreeholidays.co.uk/images';